export default "__VITE_ASSET__DjGqNBPx__"